import React, { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextValidator } from "react-material-ui-form-validator";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "../../AccountVerificationForm/AccountVerificationForm.module.css"

export default function EligibilityAutocomplete(props) {
    const {
        question,
        handlerAutocompleteChange,
        customOptions,
        displayField,
        value,
    } = props;

    const defaultValue = { value: "", label: "", extraValues: {} };
    const [autocompleteValue, setAutocompleteValue] = useState(defaultValue);
    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);
    const autoloading = false;

    useEffect(() => {
        setInputValue(value?.label ?? "");
    }, [value]);

    const autocompleteChangeHandler = (newInputValue) => {
        let valueResp;
        if (typeof newInputValue === "string") {
            valueResp = {
                value: { value: "", label: newInputValue, extraValues: {} },
                textValue: newInputValue,
            };
        } else {
            valueResp = {
                value: newInputValue || defaultValue,
                textValue: newInputValue?.label || "",
            };
        }
        setAutocompleteValue(newInputValue);
        handlerAutocompleteChange(valueResp, question.id);
    };

    const inputChangeHandler = (newInputValue) => {
        const valueResp = {
            value: {
                value: newInputValue,
                label: newInputValue,
                extraValues: {},
            },
            textValue: newInputValue,
        };
        setInputValue(newInputValue);
        handlerAutocompleteChange(valueResp, question.id);
    };

    const filterOptions = (options, { inputValue }) => {
        return options.filter((option) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    return (
        <Autocomplete
            id={question.id}
            name={question.name}
            open={open}
            freeSolo={true}
            disabled={question.disabled}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => {
                return option.label === value.label;
            }}
            getOptionLabel={(option) =>
                displayField ? option?.[displayField] : option.label
            }
            filterOptions={filterOptions}
            loading={autoloading}
            options={question.options || customOptions || []}
            noOptionsText="Not matches"
            onChange={(_, newValue) => autocompleteChangeHandler(newValue)}
            onInputChange={(_, newInputValue) =>
                inputChangeHandler(newInputValue)
            }
            value={autocompleteValue}
            inputValue={inputValue}
            renderInput={(params) => (
                <TextValidator
                    {...params}
                    id={question.id}
                    label={
                        question.required ? (
                            <div>
                                {question.label}
                                <span
                                    style={{
                                        color: "red",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    *
                                </span>
                                {" "}
                                {question.helpText &&
                                <div className={ styles.tooltip}> ?
                                    <span className={ styles.tooltipText} >{question.helpText}</span>
                                </div>
                                }
                            </div>
                        ) : (
                            <div>
                                {question.label}
                                <span style={{ fontSize: "16px"}} > {" "} </span>
                                {question.helpText &&
                                  <div className={ styles.tooltip}> ?
                                    <span className={ styles.tooltipText} >{question.helpText}</span>
                                  </div>
                                }
                            </div>
                        )
                    }
                    autoComplete="off"
                    InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        autoComplete: "off",
                        endAdornment: (
                            <React.Fragment>
                                {autoloading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={25}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    name={question.name}
                    placeholder={question.placeholder}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            )}
        />
    );
}
